module.exports = __webpack_public_path__ + "img/ic_32_sport_tennis.0a0d30b4.svg";